import React, { CSSProperties } from "react";
import cx from "classnames";
import styles from "./fieldset-title.module.scss";

export interface IFieldsetTitle {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const FieldsetTitle = (props: IFieldsetTitle) => {
  return (
    <div className={cx(styles.fieldset_title, props.className)} style={props.style} id={props.htmlId}>
      {props.children}
    </div>
  );
};

FieldsetTitle.defaultProps = {};
